// extracted by mini-css-extract-plugin
module.exports = {"switch":"Switch_switch__1UDpx","input":"Switch_input__3CSdR","inner":"Switch_inner__3PmRO","box":"Switch_box__1HTVY"};